import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue';
import Lesson from '../views/pages/lesson/Lesson.vue';
import Shop from '../views/pages/shop/Shop.vue';
import ThankYou from '../views/pages/thankyou/Thankyou.vue';
import SpecialOffer from '../views/pages/offers/SpecialOffer.vue';
import Cart from '../views/pages/cart/Cart.vue';
import AuthPage from '../views/pages/auth/AuthPage';
import ZDJInner from '../views/pages/zdjInner';
import zdjTabs from '../views/pages/zdjInner/zdjTabs.vue';

import Donate from '../views/pages/donate/Donate';
import Profile from '../views/pages/profile/Profile';
import Referral from '../views/pages/profile/Referral/Referral.vue';
import ReferralInvite from '../views/pages/profile/Referral/ReferralInvite.vue';
import ProfileEdit from '../views/pages/profile/ProfileEdit';
import { ifNotAuthenticated, ifAuthenticated } from './auth';
import SocialLoginPage from '../views/pages/SocialLoginPage';
import ManagerLoginPage from '../views/pages/ManagerLoginPage';
import RegistrationPage from '../views/pages/Registration/RegistrationPage';
import zdjService from '../services/zdj/zdjService';
import DevelopmentLoginPage from '../views/pages/DevelopmentLoginPage.vue';
import Tournaments from '../views/pages/Tournaments/Tournaments.vue';
import TournamentsOffline from '../views/pages/Tournaments/TournamentsOffline.vue';

import env from '@/enviroment';
import i18n from '@/i18n';
import lStorage from '../store/localStorage';
import store from '../store';
import {rest} from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
    {
        path:"/:locale(ro|en|ru)?",
        component: {
            beforeRouteEnter: setLocale,
            render(h) { return h('router-view'); }
        },
        children:[
            {
                path:"",
                redirect:"lesson",
            },
            {
                path:"",
                name:"Home",
                component:Home,
                children:[
                    {
                        path: "lesson",
                        name: "lesson",
                        meta: {
                            text: "Principala",
                            translate: "lesson.LBL_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: Lesson,
                    },
                    {
                        path: 'shop',
                        name: 'shop',
                        meta: {
                            text: "Magazin",
                            translate: "shop.LBL_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: Shop,
                    },
                    {
                        path: 'specialofer',
                        name: 'SpecialOffer',
                        meta: {
                            text: "Magazin",
                            translate: "shop.LBL_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: SpecialOffer,
                    },
                    {
                        path: 'cart',
                        name: 'Shopping basket',
                        meta: {
                            text: "Coș",
                            translate: "shop.LBL_CART_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: Cart,
                    },
                    {
                        path: "profile/edit",
                        name: "EditProfile",
                        meta: {
                            text: "Profilul meu",
                            translate: "profile.LBL_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: ProfileEdit,
                    },
                    {
                        path: "profile/referral",
                        name: "Referral",
                        meta: {
                            text: "Masterclass",
                            translate: "masterclass.LBL_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: Referral,
                    },
                    {
                        path: 'profile',
                        name: 'Profile',
                        meta: {
                            text: "Profilul meu",
                            translate: "profile.LBL_PAGE_TITLE"
                        },
                        beforeEnter: ifAuthenticated,
                        component: Profile,
                    },
                    {
                        path: 'donate',
                        name: 'donate',
                        meta: {
                            text: "Donează",
                            translate: "donate.LBL_PAGE_TITLE"
                        },
                        beforeEnter:(from,to,next)=>{
                            if(lStorage.get('auth-token')){
                                store.commit('loading/is',true);
                                rest.call("profile",{
                                    language:from.params.locale
                                }).then((response)=>{
                                    store.commit('loading/is',false);
                                    if(response){
                                        store.commit('user/set',response);
                                    }else{
                                        lStorage.remove('auth-token');
                                    }
                                    next();
                                }).catch((error)=>{
                                    lStorage.remove('auth-token');
                                    store.commit('loading/is',false);
                                    next();
                                });
                            }else{
                                next();
                            }
                        },
                        component: Donate,
                    },
                    {
                        path: 'gamezone/training---coordinate',
                        name: 'training---coordinate',
                        meta: {text: ''},
                        beforeEnter: zdjService.tryLoginToZDJ(ifAuthenticated),
                        component: ZDJInner,
                      },
                      {
                        path: 'gamezone/training',
                        name: 'training',
                        meta: {text: ''},
                        beforeEnter: zdjService.tryLoginToZDJ(ifAuthenticated),
                        component: ZDJInner,
                      },
                      {
                        path: 'gamezone/team/*',
                        name: 'gamezone',
                        meta: {text: ''},
                        beforeEnter: zdjService.tryLoginToZDJ(ifAuthenticated),
                        component: ZDJInner,
                      },
                      {
                        path: 'gamezone/*',
                        name: 'gamezone',
                        meta: {text: ''},
                        beforeEnter: zdjService.tryLoginToZDJ(ifAuthenticated),
                        component: zdjTabs,
                        alias: ['gamezone/*']
                      },
                      {
                        path: "tournaments",
                        name: "Tournaments",
                        meta: {
                            text: "Turnee",
                            translate: ""
                        },
                        beforeEnter: ifAuthenticated,
                        component: Tournaments,
                        children:[
                            {
                                path: 'offline',
                                name: 'offline_tournament',
                                meta: {
                                    text: "Turnee",
                                    translate: ""
                                },
                                component: TournamentsOffline,
                            },
                        ]
                    },
                ]
            },
            {
                path: "login",
                name: "LoginPage",
                beforeEnter:(route)=>{
                    if(!lStorage.get('auth-token')){
                        window.location.replace(env.homepage+"?return="+encodeURIComponent(window.location.href));
                        return;
                    }
                    router.push({
                        name:"Home",
                        params:{
                            locale:route.params.locale,
                        }
                    });
                },
                component: AuthPage,
            },
            {
                path: "register",
                name: "registration",
                component: RegistrationPage
            },
            {
                path: "social_login",
                name: "SocialLoginPage",
                component: SocialLoginPage
            },
            {
                path: "dev_login",
                name: "DevelopmentLogin",
                component: DevelopmentLoginPage
            },
            {
                path: "manager_login",
                name: "ManagerLoginPage",
                component: ManagerLoginPage
            },
            {
                path: "invite/:id(.+)?",
                name: "Invite",
                component: ReferralInvite
            },
            {
                path: "thank_you",
                name: "ThankYouPage",
                component: ThankYou
            },
        ]
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});


function setLocale(to,from,next){
    let { locale } = to.params;
    if(!locale){
        locale = env.default_locale||"ro";
    }
    i18n.locale = locale;
    next();
}

export default router
